/* eslint-disable global-require */
module.exports = ['layouts.menu.m16', 'layouts.menu.m17', 'layouts.menu.m18', 'layouts.menu.m19', 'layouts.menu.m21', 'layouts.header.m49', 'routes.estimate'];
